import { render } from "./ErrorToast.vue?vue&type=template&id=97364958"
import script from "./ErrorToast.vue?vue&type=script&lang=js"
export * from "./ErrorToast.vue?vue&type=script&lang=js"

import "./ErrorToast.vue?vue&type=style&index=0&id=97364958&lang=css"

import exportComponent from "C:\\Users\\Pablo Sastre\\OneDrive\\Escritorio\\BAIPManagerTestv2\\BaipMarket.Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__